import ProductsAPI from '~gateways/products';
import type { IProductDetail } from '~types/models-types';

// TODO: Investigate if this store is needed, and what is its role vs the products store. Maybe they can be merged?

class ProductsRepository {
  private productIdToProductMap: Record<number, IProductDetail> = {};

  public readonly loadProductAsync = async (
    productId: number
  ): Promise<IProductDetail> => {
    if (!productId) {
      // @ts-expect-error
      return null;
    }
    if (!this.productIdToProductMap[productId]) {
      this.productIdToProductMap[productId] =
        await ProductsAPI.getProductDetailAsync(productId);
    }

    return this.productIdToProductMap[productId];
  };
}

const productsRepository = new ProductsRepository();

export default productsRepository;
